<!-- //
//                _ooOoo_                                     NAM MÔ A DI ĐÀ PHẬT !
//               o8888888o
//               88" . "88                              Thí chủ con tên là Chử Văn Viên
//               (| -_- |)                            dương lịch ngày 8 tháng 10 năm 1999
//                O\ = /O
//            ____/`---'\____                  Con lạy chín phương trời, con lạy mười phương đất
//            .' \\| |// `.                       Chư Phật mười phương, mười phương chư Phật
//           / \\||| : |||// \                    Con ơn nhờ Trời đất chổ che, Thánh Thần cứu độ
//         / _||||| -:- |||||- \             Xin nhất tâm kính lễ Hoàng thiên Hậu thổ, Tiên Phật Thánh Thần
//           | | \\\ - /// | |                           Giúp đỡ con code sạch ít bug
//         | \_| ''\---/'' | | |                    Biểu diễn ko lỗi, sếp quý tăng lương
//         \ .-\__ `-` ___/-. /                       Sức khoẻ dồi dào, tiền vào như nước
//       ___`. .' /--.--\ `. . __
//    ."" '< `.___\_<|>_/___.' >'"".         NAM MÔ VIÊN THÔNG GIÁO CHỦ ĐẠI TỪ ĐẠI BI TẦM THANH CỨU KHỔ CỨU NẠN
//   | | : `- \`.;`\ _ /`;.`/ - ` : | |              QUẢNG ĐẠI LINH CẢM QUÁN THẾ ÂM BỒ TÁT
//     \ \ `-. \_ __\ /__ _/ .-` / /
//======`-.____`-.___\_____/___.-`____.-'======
//                `=---='
//^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
//
  -->
<template>
  <!-- Banner Web -->
  <div class="banner bannerWeb" v-if="!isMobile">
    <div class="inner">
      <div id="one" class="item first">
        <img :src="currentLanguage.banner_web_1" />
      </div>
    </div>
  </div>

  <!-- Banner Phone -->
  <div class="banner bannerPhone" v-else>
    <div class="inner">
      <div id="one" class="item first">
        <img :src="currentLanguage.banner_phone_1" />
      </div>
    </div>
  </div>

  <!-- Firework -->
  <div class="firework"></div>

  <main-lang></main-lang>

  <!-- Main menu -->
  <div class="wrapper row3" >
    <main class="hoc container-fluid clear">
      <div class="row">

        <!-- Left -->
        <div class="col-12 col-md-6 p-0">
          <article class="col-12 col-md-6 col-sm-6 p-2 one_fifth dv">
            <a :href="`/hu/thietbithietyeu`">
              <img class="imgmenu" style="border-radius: 8px" :src="currentLanguage.main_images_b1" />
            </a>
          </article>

          <article class="col-12 col-md-6 col-sm-6 p-2 one_fifth dv">
            <a :href="`/hu`">
              <img class="imgmenu" style="border-radius: 8px" :src="currentLanguage.main_images_b2" />
            </a>
          </article>
        </div>

        <!-- Right -->
        <div class="col-12 col-md-6 p-0">
          <article class="col-12 col-md-6 col-sm-6 p-2 one_fifth">
            <a :href="`/hu`">
              <img class="imgmenu" style="border-radius: 10px" :src="currentLanguage.main_images_b3" />
            </a>
          </article>

          <article class="col-12 col-md-6 col-sm-6 p-2 one_fifth dv">
            <a :href="`/hu`">
              <img class="imgmenu" style="border-radius: 8px" :src="currentLanguage.main_images_congTy" />
            </a>
          </article>
        </div>

      </div>
    </main>
  </div>

  <div class="wrapper row3 pt-4">
    <section class="hoc container-fluid clear p-0">
      <div class="bx-slider1"></div>
    </section>
  </div>
<!-- <MainSlideBaiViet> </MainSlideBaiViet> -->
  <FooterView class="mt-5"/>
</template>

<script>
import { languages } from "@/assets/js/languagesVMHU.js";
import FooterView from "../FooterView/FooterView.vue";
import MainLang from "./MainLang.vue";
// import MainSlideBaiViet from "./MainSlideBaiViet.vue";

export default {
  components: {
    FooterView,
    MainLang
  },

  data() {
    return {
      currentLanguage: languages.hu,
      lang: "hu",
      isMobile: false,
    };
  },

  watch: {
    $route(to) {
      const lang = to.params.lang;
      if (languages[lang]) {
        this.lang = lang;
        this.currentLanguage = languages[lang];
        this.setTitle(lang);
      }
    },
  },

  created() {
    // Load language from URL → localStorage → fallback
    const lang = this.$route.params.lang;
    const savedLang = localStorage.getItem("languages");

    this.lang = lang || savedLang || "hu";

    if (languages[this.lang]) {
      this.currentLanguage = languages[this.lang];
    }

    localStorage.setItem("languages", this.lang);
  },

  mounted() {
    this.isMobile = window.innerWidth <= 768;
    this.setTitle(this.lang);
  },

  methods: {
    setTitle(lang) {
      switch (lang) {
        case "vi":
          document.title = "Vimass.vn - Công ty Cổ phần Nền Dịch vụ Di động Việt Nam";
          break;

        case "en":
          document.title = "Vimass.vn - VIETNÁMI MOBIL ALAPÚ SZOLGÁLTATÁSOKAT NYÚJTÓ RÉSZVÉNYTÁRSASÁG";
          break;

        case "hu":
        default:
          document.title = "Vimass.vn - VIETNÁMI MOBIL ALAPÚ SZOLGÁLTATÁSOKAT NYÚJTÓ RÉSZVÉNYTÁRSASÁG";
          break;
      }
    },
  },
};
</script>

<style>
.banner {
  width: 100%;
  float: left;
  overflow: hidden;
}

.container,
.item {
  width: 100%;
  height: auto;
  /* line-height: 100px; */
}

.container,
.item img {
  width: 100%;
  height: auto;
  line-height: 100px;
}

.container {
  margin: 0 auto;
  /* height: 200px; */
  text-align: center;
  /* background: #002244;
  position: relative; */
  overflow: hidden;
  border-radius: 10px;
}

.inner {
  position: relative;
  width: 100%;
  float: left;
  display: inline;
}

.item {
  position: absolute;
  top: 0;
  left: 500px;
}

.first {
  left: 0;
  opacity: 1;
  z-index: 0;
}

.banner:hover .item {
  animation-play-state: paused;
  cursor: pointer;
}

.first {
  animation: cycleone 35s ease-in-out infinite;
  width: 100%;
  float: left;
  display: contents;
}

.second {
  animation: cycletwo 35s ease-in-out infinite;
}

.third {
  animation: cyclethree 35s ease-in-out infinite;
}

.fourth {
  animation: cyclefour 35s ease-in-out infinite;
}

@keyframes cycleone {
  0% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }

  20% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }

  25% {
    left: -500px;
    opacity: 0;
    z-index: 0;
  }

  26% {
    left: -500px;
    opacity: 0;
    z-index: -1;
  }

  27% {
    left: 500px;
    opacity: 0;
    z-index: -1;
  }

  95% {
    left: 500px;
    opacity: 0;
    z-index: 0;
  }

  100% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }
}

@keyframes cycletwo {
  0% {
    left: 500px;
    opacity: 0;
  }

  20% {
    left: 500px;
    opacity: 0;
  }

  25% {
    left: 0px;
    opacity: 1;
  }

  45% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }

  50% {
    left: -500px;
    opacity: 0;
    z-index: 0;
  }

  51% {
    left: 500px;
    opacity: 0;
    z-index: -1;
  }

  100% {
    left: 500px;
    opacity: 0;
    z-index: -1;
  }
}

@keyframes cyclethree {
  0% {
    left: 500px;
    opacity: 0;
  }

  45% {
    left: 500px;
    opacity: 0;
    z-index: -1;
  }

  50% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }

  70% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }

  75% {
    left: -500px;
    opacity: 0;
    z-index: 0;
  }

  76% {
    left: 500px;
    opacity: 0;
    z-index: -1;
  }

  100% {
    left: 500px;
    opacity: 0;
    z-index: -1;
  }
}

@keyframes cyclefour {
  0% {
    left: 500px;
    opacity: 0;
    z-index: -1;
  }

  70% {
    left: 500px;
    opacity: 0;
    z-index: 0;
  }

  75% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }

  95% {
    left: 0px;
    opacity: 1;
    z-index: 0;
  }

  100% {
    left: -500px;
    opacity: 0;
    z-index: 0;
  }
}

@font-face {
  font-family: "Seahawks";
  src: url("https://dylanjharris.net/wp-content/themes/_djh/fonts/seahawks.eot");
  src: url("https://dylanjharris.net/wp-content/themes/_djh/fonts/seahawks.eot?#iefix")
      format("embedded-opentype"),
    url("https://dylanjharris.net/wp-content/themes/_djh/fonts/seahawks.woff2")
      format("woff2"),
    url("https://dylanjharris.net/wp-content/themes/_djh/fonts/seahawks.woff")
      format("woff"),
    url("https://dylanjharris.net/wp-content/themes/_djh/fonts/seahawks.ttf")
      format("truetype"),
    url("https://dylanjharris.net/wp-content/themes/_djh/fonts/seahawks.svg#svgFontName")
      format("svg");
}

body {
  font-family: Seahawks;
}

.tcb-product-slider {
  background: #333;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 0;
}

.tcb-product-slider .carousel-control {
  width: 5%;
}

.tcb-product-item a {
  color: #147196;
}

.tcb-product-item a:hover {
  text-decoration: none;
}

.tcb-product-item .tcb-hline {
  margin: 10px 0;
  height: 1px;
  background: #ccc;
}

@media screen and (min-width: 2560px) {
  .container {
    height: 230px;
  }
}

@media screen and (min-width: 3840px) {
  .container {
    height: 250px;
  }
}

@media all and (max-width: 1694px) {
  .container-fluid1 {
    margin-right: auto;
    margin-left: auto;
    margin: 0 auto;
    height: 158px;
    text-align: center;
    overflow: hidden;
    border-radius: 0px;
  }
}

@media all and (max-width: 1366px) {
  .container-fluid1 {
    margin-right: auto;
    margin-left: auto;
    margin: 0 auto;
    height: 140px;
    text-align: center;
    overflow: hidden;
    border-radius: 0px;
  }
}

@media all and (max-width: 768px) {
  /* .item {
  position: fixed;
  top: 0;
  left: 500px;
} */
  .container-fluid1,
  .container,
  .item {
    width: 100vw;
  }

  .item {
    left: 0;
  }

  .container {
    margin: 0 auto;
    height: 180px;
    text-align: center;
    /* background: #002244;
  position: relative; */
    overflow: hidden;
    border-radius: 0px;
  }

  .inner {
    position: relative;
  }

  .tcb-product-item {
    margin-bottom: 30px;
  }
}

.tcb-product-photo {
  text-align: center;
  height: 180px;
  background: #fff;
}

.tcb-product-photo img {
  height: 100%;
  display: inline-block;
}

.tcb-product-info {
  background: #f0f0f0;
  padding: 15px;
}

.tcb-product-title h4 {
  margin-top: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tcb-product-rating {
  color: #acacac;
}

.tcb-product-rating .active {
  color: #ffb500;
}

.tcb-product-price {
  color: firebrick;
  font-size: 18px;
}

.details {
  margin: 50px 0;
}

.details h1 {
  font-size: 32px;
  text-align: center;
  margin-bottom: 3px;
}

.details .back-link {
  text-align: center;
}

.details .back-link a {
  display: inline-block;
  margin: 20px 0;
  padding: 15px 30px;
  background: #333;
  color: #fff;
  border-radius: 24px;
}

.details .back-link a svg {
  margin-right: 10px;
  vertical-align: text-top;
  display: inline-block;
}
</style>
